import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class CommerceProduct extends Vue {
  @Prop({ default: () => { } }) product!: any
  @Prop({ default: () => { } }) category!: Object

  @Getter getCartTemporal: any
  @Getter getCountry

  @Mutation CART_TEMPORAL: any

  isBtnLoad = false
  isActive = false

  _price(value) {
    let valueReturn:string = this.$currency.format(value, { code: this.getCountry.currency })
    if(this.getCountry.country_code=='co') {
      let valueReturnSplit:string[] = valueReturn.split(',')
      return valueReturnSplit[0]
    } else {
      return valueReturn[0]
    }
  }
  _discount(price, discount) {
    return price - discount
  }

  get getQuantity() {
    const cart = this.getCartTemporal
    const index = cart.findIndex((item) => item.product.id === (this.product as any).id)
    return index === -1 ? '0' : cart[index].qty
  }
  get getDiscountPrice() {
    const price = parseFloat((this.product as any).price) - parseFloat((this.product as any).discount)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  _add(product) {
    this.isActive = true
    let cart = this.getCartTemporal
    const index = cart.findIndex((item) => item.product.id === product.id)
    if (index !== -1) {
      const data = {
        product,
        qty: cart[index].qty + 1
      }
      cart.splice(index, 1, data)
      this.CART_TEMPORAL(cart)
    } else {
      const data = {
        product,
        qty: 1
      }
      this.CART_TEMPORAL([...cart, data])
    }
  }

  _goToProduct(id) {
    this.$router.push({ name: 'product', params: { id: id } })
  }
}
